import { useFormContext } from 'react-hook-form'

import { ControlledNumberInput, FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface QuantityFormFieldProps {}

export const QuantityFormField: React.FC<QuantityFormFieldProps> = ({}) => {
  const { control, register } = useFormContext<{ quantity: number }>()

  return (
    <FormField
      name="quantity"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Quantity</FormLabel>
              <FormError />
            </div>
            <ControlledNumberInput
              thousandSeparator={','}
              placeholder={'Quantity'}
              {...register('quantity', { valueAsNumber: true })}
            />
          </FormItem>
        )
      }}
    />
  )
}
